/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { formatGeoNumForPersist } from 'aegion_common_utilities/lib/format/numeric';
import { ajaxNew as ajax } from '../../../scanline/utils/ajax';

const sanitizeReadingLatLng = (reading) => {
  if (reading?.coordinates && reading.coordinates instanceof Array && reading.coordinates.length > 1) {
    reading.coordinates[0] = formatGeoNumForPersist(reading.coordinates[0]);
    reading.coordinates[1] = formatGeoNumForPersist(reading.coordinates[1]);
  }
}

// strange data structure edits => [{ edits: [{ reading: {}, type, index }], ...remainingProps}];
const sanitizeEdits = (edits) => {
  const listEdits = _.cloneDeep(edits);
  if (listEdits instanceof Array) {
    listEdits.forEach(meta => {
      (meta.edits || []).forEach(edit => {
        sanitizeReadingLatLng(edit?.reading);
      })
    });
  }
  
  return listEdits;

}

// eslint-disable-next-line import/prefer-default-export
export function sendEdits(id, edits) {
  const sanitizedEdits = sanitizeEdits(edits);
	return ajax({
		aip: 'cisviewedits',
		url: `/edits/${id}`,
		data: JSON.stringify(edits),
		method: 'POST'
	});
}
